module.exports = __webpack_public_path__ + "static/media/pohled-do-cely2.093e4d29.jpg";